import { Injectable, Input } from '@angular/core';
import { InputValidationTypes } from '../input/InputValidationTypes.enum';
import { max } from 'moment';
@Injectable()
export class ValidationService {
  constructor() {}

  public validateDomainName(input: string, required: boolean): { result: boolean; resValue: string } | any {
    if (!input || input.trim().length === 0) {
      return !required;
    }
    const isProtocol = input.indexOf('http://') !== -1 || input.indexOf('https://') !== -1;
    let resValue = isProtocol ? input.slice(input.indexOf('//') + 2) : input;
    const idxPathSlash = resValue.indexOf('/');
    resValue =
      idxPathSlash !== -1 && resValue.slice(idxPathSlash).indexOf('.') === -1
        ? resValue.slice(0, idxPathSlash)
        : resValue;
    const pattern = /^([a-z0-9]+(-[a-z0-9]+)*\.)+[a-z]{2,}$/;
    const result = pattern.test(
      Array.isArray(resValue) ? resValue[0].trim().toLowerCase() : resValue.trim().toLowerCase(),
    );
    return { result, resValue };
  }

  public validateEmailAddress(input: string, required: boolean) {
    if (!input || input.trim().length === 0) {
      return !required;
    }
    const pattern =
      /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return pattern.test(input.trim().toLowerCase());
  }

  public validateInput(
    input: string,
    validations: InputValidationTypes[],
    minLength: number,
    maxLength?: number,
  ): string | any {
    const inputRequired = validations.indexOf(InputValidationTypes.Required) !== -1;
    if (inputRequired) {
      if (!input || input.trim().length === 0) {
        return 'generic.validation.error-required';
      }
    }
    if (validations.indexOf(InputValidationTypes.MinLength) !== -1) {
      const _minLength = minLength ? minLength : 4;
      if (!input || input.trim().length < _minLength) {
        return 'generic.validation.error-minlength-4';
      }
    }
    if (validations.indexOf(InputValidationTypes.Domain) !== -1) {
      if (!this.validateDomainName(input, inputRequired).result) {
        return { error: 'generic.validation.error-domain', resValue: '' };
      }
      if (validations.indexOf(InputValidationTypes.MaxLength) !== -1 && maxLength && input.length > maxLength) {
        return {
          error: this.getMaxLengthErrorMessage(maxLength),
          resValue: this.validateDomainName(input, inputRequired).resValue,
        };
      }
      return {
        error: '',
        resValue: this.validateDomainName(input, inputRequired).resValue,
      };
    }
    if (validations.indexOf(InputValidationTypes.Email) !== -1) {
      if (!this.validateEmailAddress(input, inputRequired)) {
        return 'generic.validation.error-email';
      }
    }
    if (validations.indexOf(InputValidationTypes.Protocal) !== -1) {
      if (!input) return;
      const isProtocol = input.indexOf('http://') !== -1 || input.indexOf('https://') !== -1;
      if (!isProtocol) {
        return 'generic.validation.error-protocol';
      }
    }

    if (validations.indexOf(InputValidationTypes.MaxLength) !== -1 && maxLength) {
      if (input && input.length > maxLength) {
        return this.getMaxLengthErrorMessage(maxLength);
      }
    }
    return undefined;
  }

  private getMaxLengthErrorMessage(maxLength: number): string {
    switch (maxLength) {
      case 50:
        return 'generic.validation.error-maxlength-50';
      case 100:
        return 'generic.validation.error-maxlength-100';
      case 200:
        return 'generic.validation.error-maxlength-200';
      default:
        return 'generic.validation.error-maxlength';
    }
  }
}
